interface ToggleProps {
  options: [string, string]
  value: string
  onChange: (value: string) => void
  className?: string
}

export default function Toggle({ options, value, onChange, className = '' }: ToggleProps) {
  const [left, right] = options

  return (
    <div
      className={`
        inline-flex
        bg-white/[0.03]
        border border-white/10
        rounded-lg
        p-1
        ${className}
      `}
    >
      <button
        type="button"
        onClick={() => onChange(left)}
        className={`
          px-6 py-3
          text-sm font-medium
          rounded-md
          transition-all duration-300
          ${
            value === left
              ? 'bg-button-teal text-[#1a1f2e] shadow-sm'
              : 'bg-transparent text-brand-muted hover:text-brand-light'
          }
        `}
      >
        {left}
      </button>
      <button
        type="button"
        onClick={() => onChange(right)}
        className={`
          px-6 py-3
          text-sm font-medium
          rounded-md
          transition-all duration-300
          ${
            value === right
              ? 'bg-button-teal text-[#1a1f2e] shadow-sm'
              : 'bg-transparent text-brand-muted hover:text-brand-light'
          }
        `}
      >
        {right}
      </button>
    </div>
  )
}
